import React, { useState, useRef } from 'react';
import get from 'lodash/get';
import { useResizeX } from 'Hooks/useResize';
import useWindowDimensions from 'Hooks/useWindowSize';
import { EEFeatureSlot } from 'Common/ee/EEFeatureSlot';
import Header from './components/Header';
import {
  Wrapper, ResizerWrapper, DetailWrapper, Resizer,
  Transparency, Content
} from './styled';
import Description from './components/Description';
import TechnicalInfo from './components/TechnicalInfo';
import Customer from './components/Customer';
import WorkspaceGroupingConfirmModal from './components/TechnicalInfo/GroupingConfirmModal';

const WorkspaceDetail = () => {
  const [showTransparency, setShowTransparency] = useState(false);
  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const resizerRef = useRef(null);
  const { width } = useWindowDimensions();
  const minWidth = width < 3000 ? width * 0.55 : width * 0.35;
  const maxWidth = width < 3000 ? width * 0.75 : width * 0.55;
  const wrapperWidth = useResizeX(wrapperRef, resizerRef, minWidth, minWidth, maxWidth);

  const onScroll = () => {
    const scrollTop = get(ref, 'current.scrollTop', 0);
    if (scrollTop === 0) setShowTransparency(false);
    else setShowTransparency(true);
  };

  return (
    <>
      <Wrapper ref={ wrapperRef } wrapperWidth={ wrapperWidth }>
        <ResizerWrapper ref={ resizerRef } children={ <Resizer /> } />
        <DetailWrapper>
          <Header />
          { showTransparency && <Transparency /> }
          <Content tabRef={ ref } onScroll={ onScroll } showTransparency={ showTransparency }>
            <TechnicalInfo />
            <EEFeatureSlot featureKey="workspace-detail-users" />
            <Description />
            <Customer />
          </Content>
        </DetailWrapper>
      </Wrapper>
      <WorkspaceGroupingConfirmModal />
    </>
  );
};

export default WorkspaceDetail;
